export default (function() {
  // const host_url = 'http://localhost:8080'
  // const api_url = 'http://localhost:28209'
  // const host_url = 'http://update.jinsolutions.com'
  // const api_url = 'http://update.jinsolutions.com:28209'

  const host_url = 'https://update.jinsolutions.com'
  const api_url = 'https://update.jinsolutions.com:28209'

  const resource_url = 'https://update.jinsolutions.com/resources'
  const websocket_api_url = 'wss://update.jinsolutions.com:28209'

    return {
    HOST_NAME: host_url,
    HOST_NAME_API: api_url,
    HOST_NAME_RESOURCE: resource_url,
    WEBSOCKET_STATE: 'ON',
    // WEBSOCKET_STATE: 'OFF',
    WEBSOCKET_API: websocket_api_url,
    CONFIG: {
      ON: 'ON',
      OFF: 'OFF',
      TIMEOUT: 60,// In minutes(default = 60, 1 year = 525600)
      ENC: 'SHA-256',
    },
    ACCOUNT : {
      ACCESS_FULL: 'FULL_ACCESS'
    },
    APPLICATION : {
      URL_HOME: '/service/home',
      ACTION_TYPE_CONST_BLOCK_DIV: 'blockdiv',
      ACTION_TYPE_CONST_MOD_DASH: 'moddash'
    },
    NAVIGATION: {
      NAME_PHASE: 'Phase',
      NAME_GROUP: 'Group',
      NAME_ITEM: 'Item',
      NAME_SUBITEM: 'Subitem',
      PATH_TO_NAME: {
        '/sysenv/config/nav/phase': 'Phase',
        '/sysenv/config/nav/group':  'Group',
        '/sysenv/config/nav/item':  'Item',
        '/sysenv/config/nav/subitem':  'Subitem',
      },
      PATH_TO_COMPONENT: {
        '/sysenv/config/nav/phase': 'SysenvNavPhase',
        '/sysenv/config/nav/group': 'SysenvNavGroup',
        '/sysenv/config/nav/item': 'SysenvNavItem',
        '/sysenv/config/nav/subitem': 'SysenvNavSubitem',
      },
    },
    LOCAL_STORAGE_NAME: {
      TOKEN: '',
      TIMEOUT: '',
      ACCOUNT: 'ACCOUNT',
      APP_SERVICE_FILTERED_VALUES: 'FILTERED_VALUES_',
      APP_SERVICE_CONFIG_PROPS: 'CONFIG_PROPS_',
      APP_SERVICE_PAGE_PROPS: 'PAGE_PROPS_',
      ENVIRONMENT: 'ENVIRONMENT',
    },
    STORE_NAMESPACE: {
      ACCOUNT: 'account',
      MENU: 'menu'
    },
  }
})()
